import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { UrlService } from '@x/ecommerce-shop/app/core/url/url.service';
import { IShopProductDetail, IShopTaxonDetail, IShopTaxonItem } from '@x/ecommerce/shop-client';

interface BreadCrumb {
  name: string;
  url?: string;
}

@Component({
  selector: 'x-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbComponent implements OnChanges {
  crumbs: BreadCrumb[] = [];

  @Input() excludedIndices: number[] = [];
  @Input() ascendents: IShopTaxonItem[] | undefined;

  @Input() currentTaxon: IShopTaxonDetail | undefined;

  @Input() includeCurrentProduct = true;
  @Input() currentProduct: IShopProductDetail | undefined;

  constructor(private urlService: UrlService) {}

  ngOnChanges() {
    this.populateCrumbs();
  }

  populateCrumbs() {
    if (!this.ascendents) return;

    this.crumbs = this.ascendents.reduce<BreadCrumb[]>(
      (acc, { name, id, slug, parentId }, index) => {
        if (this.excludedIndices.includes(index)) return acc;

        const crumb =
          id === 1 || parentId === 1
            ? { name, url: this.urlService.taxonUrl(id, slug) }
            : { name, url: this.urlService.productListingUrl(id, slug) };

        acc.push(crumb);
        return acc;
      },
      [],
    ) as BreadCrumb[];

    if (this.currentTaxon)
      this.crumbs = [
        ...this.crumbs,
        {
          name: this.currentTaxon.name,
          url: this.urlService.productListingUrl(this.currentTaxon.id, this.currentTaxon.slug),
        },
      ];

    if (this.includeCurrentProduct && this.currentProduct)
      this.crumbs = [...this.crumbs, { name: this.currentProduct.name }];
  }
}
